import React from 'react';
import './Icon.css';

/**
 * Icon wrapper that enforces monochrome styling and consistent sizing.
 * Usage: <Icon icon={Trophy} size={24} className="mb-2" />
 */
const Icon = ({ icon: IconComp, size = 24, className = '', title }) => {
  const pixel = typeof size === 'number' ? size : 24;
  return (
    <span className={`mono-icon ${className}`} style={{ width: pixel + 16, height: pixel + 16 }} aria-label={title}>
      {IconComp ? <IconComp size={pixel} color="#d97706" strokeWidth={2} /> : null}
    </span>
  );
};

export default Icon;
